// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_gJ","advertCardHeader__actions":"c-a_gK","advertCardHeader__bottomLabel":"c-a_gL"};